import { Credentials, User } from '../../types';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';
export const GET_SESSION = 'GET_SESSION';
export const GET_SESSION_ERROR = 'GET_SESSION_ERROR';
export const GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
export const UPDATE_SESSION_FETCHED_STATE = 'UPDATE_SESSION_FETCHED_STATE';

export interface AuthState {
    isUserLoggedIn: boolean;
    user: User | null;
    sessionHasBeenFetched: boolean;
}

export interface LoginAction {
    type: typeof LOGIN;
    payload: Credentials;
}

export interface LogoutAction {
    type: typeof LOGOUT;
}
export interface SetUserAction {
    type: typeof SET_USER;
    payload: { user: User };
}
export interface GetSessionAction {
    type: typeof GET_SESSION;
}
export interface GetSessionSuccessAction {
    type: typeof GET_SESSION_SUCCESS;
    payload: {
        user: User;
    };
}
export interface GetSessionErrorAction {
    type: typeof GET_SESSION_ERROR;
    payload: {
        error: any;
    };
}

type GetSessionActionType = GetSessionAction | GetSessionSuccessAction | GetSessionErrorAction;

export interface UpdateSessionStateFetchedAction {
    type: typeof UPDATE_SESSION_FETCHED_STATE;
}

export type AuthActionTypes =
    | LoginAction
    | LogoutAction
    | SetUserAction
    | GetSessionActionType
    | UpdateSessionStateFetchedAction;
